import React from 'react'

import { Translate } from '@hozana/intl/Translate'
import { QA } from '@hozana/tests/constants'

import { Text } from 'elements/text/Text'
import { Alert, TAlertProps } from 'elements/ui/Alert'

import { ICON } from 'config/icons'

import { getCommunityDates } from 'modules/community/functions'

import type { TCommunity } from '../types'

export type TCommunityDatesProps = {
  community: TCommunity
} & TAlertProps

export const CommunityDates: TFCC<TCommunityDatesProps> = ({ community, ...otherProps }) => {
  const { novenaOrRetreat, isMember, lifetime, fromDate, toDate, finishedAt, retreatStatus } =
    getCommunityDates(community)

  if (novenaOrRetreat) {
    // Text
    let text = 'trans:community:community.retreat.dates.options' // {Neuvaine} du ... au ...
    let status: TAlertProps['status'] = 'transparent'
    if (retreatStatus?.finished && !retreatStatus.scheduled && !retreatStatus?.reliving) {
      text = 'trans:community:community.retreat.dates.finished' // Vous avez participé à la {neuvaine} en ... - Recommencez quand vous voulez !
      status = 'info'
    } else if (isMember && ((retreatStatus?.ongoing && !retreatStatus.scheduled) || retreatStatus?.reliving)) {
      text = 'trans:community:community.retreat.dates.ongoing' // Vous participez à la {neuvaine} du ... au ...
      status = 'success'
    } else if (isMember && (retreatStatus?.scheduled || retreatStatus?.comingSoon)) {
      text = 'trans:community:community.retreat.dates.unstarted' // Vous participerez à la {neuvaine} du ... au ...
      status = 'success'
    } else if (retreatStatus?.toRediscover && !retreatStatus?.finished) {
      text = 'trans:community:community.retreat.start-when-you-want' // Commencez la {neuvaine} quand vous voulez !
    }

    return (
      <Alert
        icon={ICON.CALENDAR}
        status={status}
        hideCloseButton
        data-testid={QA.COMMUNITY_COMMON.DATES}
        {...otherProps}
      >
        <Text lowercase firstUpper>
          <Translate values={{ lifetime, fromDate, toDate, finishedAt }}>{text}</Translate>
        </Text>
      </Alert>
    )
  } else {
    return (
      <>
        {isMember && (
          <Alert icon={ICON.CHECK} hideCloseButton data-testid={QA.COMMUNITY_COMMON.DATES} {...otherProps}>
            trans:community:community.everlasting.you-are-member
          </Alert>
        )}
      </>
    )
  }
}
